import { cx } from 'emotion';
import { CSSProperties, memo } from 'react';

import {
  Container,
  GameStatusLabel,
  progressBarAnimation,
  noProgressAnimation,
} from './style';

type ProgressBarProps = Readonly<{
  progress: number;
  totalTime: number;
  label: string;
  color: string;
  state: string;
  timeString: string;
  timeLeft: number;
  style?: CSSProperties;
  className?: string;
}>;

function ProgressBar({
  progress,
  totalTime,
  label,
  color,
  state,
  timeString,
  timeLeft,
  className,
}: ProgressBarProps) {
  return (
    <Container
      className={cx(
        {
          [progressBarAnimation(totalTime, timeLeft)]: timeLeft > 0 && progress >= 0,
          [noProgressAnimation]: progress < 0,
        },
        className
      )}
      color={color}
      data-e2e="progress-bar"
      data-current-seconds={timeLeft}
      data-round-status={state}
    >
      <GameStatusLabel>
        <span>{progress < 0 ? '' : timeString}</span>
        {' '}
        {label}
      </GameStatusLabel>
    </Container>
  );
}

export default memo(ProgressBar);
